<template>
  <div>
    <iModal title="直播设置" v-model="showModal" class-name="vertical-center-modal" width="800px" :mask-closable="false"
      @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100"
            @submit.native.prevent>
            <FormItem label="直播模板：" prop="liveTemplate" required>
              <div class="select-box">
                <div class="select-title">选择开播模板(创建后不可修改)</div>
                <div class="select-item" :class="{select: templateNum === 1}" @click="selectionHandle(1)">文档+视频（三分屏）<img src="@assets/img/live/select.png"></div>
                <div class="select-item" :class="{select: templateNum === 2}" @click="selectionHandle(2)">纯视频<img src="@assets/img/live/select.png"></div>
                <div class="select-title">选择观看模板(创建后可修改)</div>
                <div class="select-item" :class="{select: templateNum2 === 1}" @click="selectionType(1)">横屏<img src="@assets/img/live/select.png"></div>
                <div class="select-item" :class="{select: templateNum2 === 2}" @click="selectionType(2)">竖屏<img src="@assets/img/live/select.png"></div>
              </div>
            </FormItem>
            <FormItem label="直播延迟：" prop="liveEnableNotDelay" class="ivu-form-item-required">
              <div class="select-box2">
                <div class="select-item" :class="{select: !formInline.liveEnableNotDelay}" @click="formInline.liveEnableNotDelay = false"><img src="@assets/img/live/icon-1.png" />正常延迟≈3s</div>
                <div class="select-item" :class="{select: formInline.liveEnableNotDelay}" @click="formInline.liveEnableNotDelay = true"><img src="@assets/img/live/icon-2.png" />无延迟<0.4s </div>
                <Tooltip placement="top" theme="light" max-width="500">
                  <span class="tip-txt"><Icon type="ios-information-circle-outline" size="14"/>无延迟直播</span>
                  <div slot="content" style="width: 400px" >
                    <p>开播：支持网页开播与win版客户端4.0及以上版本</p>
                    <p>观看：支持Chrome、微信、iOS13及以上Safari浏览器</p>
                    <p>移动端sdk：支持1.0及以上版本</p>
                    <p>JS-SDK：支持1.8及以上版本</p>
                    <p>连麦：支持Chrome、微信、iOS13及以上Safari浏览器</p>
                  </div>
                </Tooltip>
                <div class="select-title"><Icon type="ios-information-circle-outline" size="14"/>无延迟直播延迟低于0.4s（大直播正常延迟～3s），支持微信连麦</div>
              </div>
            </FormItem>
            <FormItem label="直播日期：" prop="date">
              <DatePicker type="date" placeholder="选择直播日期" style="width: 300px" v-model="formInline.date">
              </DatePicker>
            </FormItem>
            <FormItem label="直播时间：" prop="time">
              <TimePicker type="timerange" placeholder="选择直播时间" style="width: 300px" v-model="formInline.time">
              </TimePicker>
            </FormItem> 
            <FormItem label="联系人：" prop="liveLinkName">
              <Input v-model="formInline.liveLinkName" placeholder="请输入联系人" style="width: 300px" />
            </FormItem>
            <FormItem label="手机号：" prop="livelinkTel">
              <Input v-model="formInline.livelinkTel" placeholder="请输入手机号" style="width: 300px" />
            </FormItem> 
          </Form>
          <div class="showType">
            <img src="@assets/img/live/live-bg-1.jpg" v-if="templateNum === 1 && templateNum2 === 1" />
            <img src="@assets/img/live/live-bg-2.jpg" v-if="templateNum === 2 && templateNum2 === 1" />
            <img src="@assets/img/live/live-bg-3.jpg" v-if="templateNum === 1 && templateNum2 === 2" />
            <img src="@assets/img/live/live-bg-4.jpg" v-if="templateNum === 2 && templateNum2 === 2" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions } from "vuex";

export default {
  name: "open-live",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    const that = this;
    const validDate = (rule, value, callback) => {
      if (value) {
        let now = new Date().getTime() - 86400000;
        let start = new Date(value).getTime();
        if (now > start) {
          callback(new Error("直播开始日期不能小于当前日期"));
        } else {
          callback();
        }
        callback();
      } else {
        callback(new Error("直播日期不能为空"));
      }
    };
    const validTime = (rule, value, callback) => {
      if (value && value[0] && value[1]) {
        if (!that.formInline.date) {
          callback();
        } else {
          let date = `${moment(that.formInline.date).format("YYYY-MM-DD")} ${value[0]}`
          let now = new Date().getTime();
          let start = new Date(date).getTime();
          if (now > start) { // 选择的时间节点小于当前时间 则无效 
            callback(new Error("直播开始时间不能小于当前时间"));
          } else {
            callback();
          }
        }
      } else {
        callback(new Error("直播时间不能为空"));
      }
    };
    const validPhone = (rule, value, callback) => {
      if (!value) {
        callback('请输入手机号码');
      } else if (/^[1][0-9]{10}$/.test(value)) {
        callback();
      } else {
        callback('请输入正确的手机号码');
      }
    };
    return {
      loading: false,
      showModal: true,
      templateNum: 1, //  1文档+视频 2纯视频
      templateNum2: 1, //  1横屏 2竖屏
      formInline: {
        date: '',
        time: [],
        liveLinkName: '',
        livelinkTel: '',
        liveTemplate: 'ppt', // ppt:三分屏(横屏)、 portrait_ppt：三分屏(竖屏)、 alone：纯视频(横屏) 、 portrait_alone：纯视频(竖屏) 、 topclass：纯视频-极速(横屏) 、 portrait_topclass：纯视频-极速(竖屏)
        liveEnableNotDelay: true, // ppt:三分屏(横屏)、 portrait_ppt：三分屏(竖屏)、 alone：纯视频(横屏) 、 portrait_alone：纯视频(竖屏) 、 topclass：纯视频-极速(横屏) 、 portrait_topclass：纯视频-极速(竖屏)
      
      },
      ruleInline: {
        date: [{ required: true, validator: validDate, trigger: "change" }],
        time: [{ required: true, validator: validTime, trigger: "change" }],
        liveLinkName: [{ required: true, message: "联系人不能为空", trigger: "blur" }],
        livelinkTel: [{ required: true, validator: validPhone, trigger: "blur" }],
      }
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
  },
  methods: {
    ...mapActions({
      applyLive: "liveModule/applyLive",
    }),
    async handleSubmit (name) {
      if (!this.info) return;
      let valid = await this.validForm(name);
      if (!valid) return;
      let startTime = `${moment(this.formInline.date).format("YYYY-MM-DD")} ${this.formInline.time[0]}`;
      let endTime = `${moment(this.formInline.date).format("YYYY-MM-DD")} ${this.formInline.time[1]}`;
      let type = 'ppt';
      if(this.templateNum === 1 && this.templateNum2 === 1 ) {
        type = 'ppt'
      }
      if(this.templateNum === 1 && this.templateNum2 === 2 ) {
        type = 'portrait_ppt'
      }

      if(this.templateNum === 2 && this.templateNum2 === 1 ) {
        type = 'alone'
      }
      if(this.templateNum === 2 && this.templateNum2 === 2 ) {
        type = 'portrait_alone'
      }
      let req = {
        activityId: this.info.id,
        liveStartTime: startTime,
        liveEndTime: endTime,
        liveLinkName: this.formInline.liveLinkName,
        livelinkTel: this.formInline.livelinkTel,
        liveTemplate: type,
        liveEnableNotDelay: this.formInline.liveEnableNotDelay,
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.applyLive(req).catch(err => {
        this.loading = false;
      });
      this.loading = false;
      if (!bool) {
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("直播申请已提交，等待审核");
        this.cancel();
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    },
    selectionHandle (val) {
      this.templateNum = val;
    },
    selectionType (val) {
      this.templateNum2 = val;
    },
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    position: relative;
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
  .select-box {
    .select-title {
      font-size: 12px;
      color: rgb(117, 117, 117);
    }
    .select-item {
      min-width: 80px;
      height: 36px !important;
      padding: 0 16px;
      border-radius: 2px;
      border: 1px solid #cfd8dc;
      -webkit-transition: border-color 0.35s;
      transition: border-color 0.35s;
      position: relative;
      margin-right: 16px;
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      cursor: pointer;
      &.select {
        border-color: rgb(33, 150, 243) !important;
        img {
          opacity: 1;
        }
      }
      img {
        opacity: 0;
        position: absolute;
        width: 10px;
        height: 10px;
        right: 0;
        bottom: 0;
      }
    }
  }
  .select-box2 {
    .select-title {
      font-size: 12px;
      color: rgb(117, 117, 117);
    }
    .select-item {
      min-width: 80px;
      height: 36px !important;
      padding: 0 16px;
      border-radius: 2px;
      border: 1px solid #cfd8dc;
      -webkit-transition: border-color 0.35s;
      transition: border-color 0.35s;
      position: relative;
      margin-right: 16px;
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      &.select {
        border-color: rgb(33, 150, 243) !important; 
      }
    }
  }
}

.tip-txt {
  position: relative;
  top: -5px;
  color: rgb(33, 150, 243);
  cursor: pointer;
}
.showType {
  position: absolute;
  text-align: center;
  position: absolute;
  text-align: center;
  top: 20px;
  right: 10px;
  img {
    width: 134px !important;
    height: 287px !important;
  }
}
</style>

